export const APP_NAME = 'customerCard';

export const CUSTOMER_CARD_ROUTE_ROOT = '/customerCard';
